import { Component, Input, ViewEncapsulation } from '@angular/core';

import { Contact } from '@mobi/mcs-schadenmeldung-types-ng-jslib';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class ContactComponent {
    @Input() contact: Contact;
}
